import {
  CommonActions,
  createNavigationContainerRef,
  ParamListBase,
  StackActions,
} from '@react-navigation/native'

export const isReadyRef = {
  current: false,
}

export const navigationRef = createNavigationContainerRef<ParamListBase>()

export function navigate(name: string, params?: object) {
  if (isReadyRef.current && navigationRef.isReady()) {
    // Perform navigation if the app has mounted
    navigationRef.dispatch(CommonActions.navigate({ name, params }))
  } else {
    // You can decide what to do if the app hasn't mounted
    // You can ignore this, or add these actions to a queue you can call later
    // push(name, params);
  }
}

export function push(name: string, params?: object) {
  if (navigationRef.isReady()) {
    navigationRef.dispatch(StackActions.push(name, params))
  }
}
